import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
const dayjs = window.dayjs;
export default class LineupUserScoresModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.userStat = this.attrs.userStat;
    this.matches = this.attrs.matches;
    this.seasonSlug = this.attrs.seasonSlug;
    this.loading = false;
    this.expandedMatches = {};
    if (Object.keys(this.userStat.matchScores || {}).length === 0) {
      this.loadScores();
    }
  }
  loadScores() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/lineup-classification",
      params: {
        season: this.seasonSlug,
        user_id: this.userStat.user.id(),
        include: 'match'
      }
    }).then(response => {
      const scores = app.store.pushPayload(response);
      const matchScores = {};
      scores.forEach(s => {
        const match = s.match();
        if (match) {
          matchScores[match.id()] = s;
        }
      });
      this.userStat.matchScores = matchScores;
      this.loading = false;
      m.redraw();
    });
  }
  toggleMatchExpansion(matchId, e) {
    if (e) e.stopPropagation();
    this.expandedMatches[matchId] = !this.expandedMatches[matchId];
    m.redraw();
  }
  className() {
    return 'LineupUserScoresModal PlayerStatsModal Modal--large';
  }
  title() {
    return ''; // Title is handled in the header
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    const user = this.userStat.user;
    const totalPoints = this.userStat.points;
    const gamesPlayed = this.userStat.matchCount;
    const average = gamesPlayed > 0 ? (totalPoints / gamesPlayed).toFixed(1) : 0;
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Player-Modal-Header"
    }, m("div", {
      className: "Player-Profile"
    }, avatar(user, {
      className: 'Player-Avatar-Large'
    }), m("div", {
      className: "Player-Info"
    }, m("h2", null, username(user)), m("span", {
      className: "entity-tag"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.user')))), m("div", {
      className: "Player-Main-Stats"
    }, m("div", {
      className: "Stat-Box Highlight"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.points'), ":"), m("span", {
      className: "value"
    }, totalPoints)), m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.matches'), ":"), m("span", {
      className: "value"
    }, gamesPlayed)), m("div", {
      className: "Stat-Box"
    }, m("span", {
      className: "label"
    }, app.translator.trans('nagusi-match-ratings.forum.modal.average'), ":"), m("span", {
      className: "value"
    }, average)))), m("div", {
      className: "Match-History-Section"
    }, m("h3", null, app.translator.trans('nagusi-match-ratings.forum.modal.history_title')), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('nagusi-match-ratings.forum.classification.match')), m("th", null, app.translator.trans('nagusi-match-ratings.forum.modal.date')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.classification.points')))), m("tbody", null, this.matches.filter(match => this.userStat.matchScores[match.id()] !== undefined).reduce((acc, match) => {
      const scoreRecord = this.userStat.matchScores[match.id()];
      const points = scoreRecord.points();
      const predictedLineup = scoreRecord.predictedLineup() || [];
      const officialLineup = scoreRecord.officialLineup() || [];
      const isExpanded = !!this.expandedMatches[match.id()];
      const hasPredicted = predictedLineup.length > 0;
      acc.push(m("tr", {
        className: "row-item ".concat(isExpanded ? 'row-expanded' : ''),
        key: "row-".concat(match.id()),
        onclick: hasPredicted ? this.toggleMatchExpansion.bind(this, match.id()) : undefined,
        style: hasPredicted ? {
          cursor: 'pointer'
        } : undefined
      }, m("td", null, m("div", {
        className: "Match-Info",
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, hasPredicted && m("i", {
        className: "fas fa-chevron-".concat(isExpanded ? 'down' : 'right'),
        style: {
          marginRight: '8px',
          fontSize: '0.85em',
          color: '#64748b'
        }
      }), m("strong", null, match.getName()))), m("td", null, match.matchDate() ? dayjs(match.matchDate()).format('LL') : ''), m("td", {
        className: "center bold"
      }, points)));
      if (isExpanded && hasPredicted) {
        acc.push(m("tr", {
          className: "row-detail",
          key: "detail-".concat(match.id())
        }, m("td", {
          colSpan: "3"
        }, m("div", {
          className: "LineupUserScoresModal-detail-box"
        }, officialLineup.length > 0 && m("div", {
          className: "detail-section"
        }, m("div", {
          className: "detail-title"
        }, m("i", {
          className: "fas fa-futbol",
          style: {
            marginRight: '6px'
          }
        }), "Alineaci\xF3n Oficial Titular:"), m("div", {
          className: "detail-players"
        }, officialLineup.map((p, idx) => m("span", {
          className: "detail-player-badge",
          key: idx
        }, p.name)))), m("div", {
          className: "detail-section"
        }, m("div", {
          className: "detail-title"
        }, m("i", {
          className: "fas fa-user-edit",
          style: {
            marginRight: '6px'
          }
        }), "Pron\xF3stico del Forero:"), m("div", {
          className: "detail-players"
        }, predictedLineup.map((p, idx) => m("span", {
          className: "detail-player-badge ".concat(p.is_match ? 'match' : 'mismatch'),
          key: idx
        }, m("i", {
          className: "fas ".concat(p.is_match ? 'fa-check' : 'fa-times'),
          style: {
            marginRight: '4px'
          }
        }), p.name))))))));
      }
      return acc;
    }, []))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/LineupUserScoresModal', LineupUserScoresModal);